import React from 'react';
import { Grid } from '@mui/material';

import { Company } from '../../../models/company.model';
import { CustomerWithId } from '../../../models/customer.model';
import CustomerDetailsCard from '../../../common/customer-details-card/CustomerDetailsCard';

interface DetailsTabsProps {
  company: Company;
  customer: CustomerWithId;
  key: string;
}

const DetailsTabs: React.FC<DetailsTabsProps> = ({ customer }) => {
  return (
    <>
      <Grid component='div' container wrap='wrap' style={{ rowGap: '16px', paddingBottom: '16px' }}>
        <Grid component='div' size={{ xs: 12 }}>
          <CustomerDetailsCard customer={customer} />
        </Grid>
        <Grid component='div' size={{ xs: 12 }}>
          <CustomerDetailsCard simplified preferences customer={customer} />
        </Grid>

        {/* <Grid component='div' size={{xs: 12}}>
          <EmploymentCard employee={customer} />
        </Grid>

        <Grid component='div' size={{xs: 12}}>
          <QualificationsCard employee={customer} />
        </Grid>

        <Grid component='div' size={{xs: 12}}>
          <EmergencyContactCard employee={customer} />
        </Grid> */}
      </Grid>
    </>
  );
};

export default DetailsTabs;
